import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import * as styles from './arts.css';

// The two ~30KB art SVG modules are decorative and only needed when the
// experimental-features prompt actually renders — load them on mount instead of
// shipping them in the initial bundle (null until loaded).
export const ExperimentalFeatureArts = () => {
  const { resolvedTheme } = useTheme();
  const [arts, setArts] = useState<{ dark: string; light: string } | null>(
    null
  );

  useEffect(() => {
    let cancelled = false;
    Promise.all([import('./dark-art-svg'), import('./light-art-svg')])
      .then(([dark, light]) => {
        if (!cancelled) {
          setArts({ dark: dark.default, light: light.default });
        }
      })
      .catch(console.error);
    return () => {
      cancelled = true;
    };
  }, []);

  if (!arts) {
    return null;
  }

  return (
    <div
      className={styles.root}
      dangerouslySetInnerHTML={{
        __html: resolvedTheme === 'dark' ? arts.dark : arts.light,
      }}
    />
  );
};
